export default __webpack_public_path__ + "static/media/welcome.d8120c96.svg";